import { render } from "./BankDetailsComponent.vue?vue&type=template&id=51c7a00f&ts=true"
import script from "./BankDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./BankDetailsComponent.vue?vue&type=script&lang=ts"

import "./BankDetailsComponent.vue?vue&type=style&index=0&id=51c7a00f&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/buyCrypto/BankDetailsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51c7a00f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51c7a00f', __exports__)) {
    api.reload('51c7a00f', __exports__)
  }
  
  module.hot.accept("./BankDetailsComponent.vue?vue&type=template&id=51c7a00f&ts=true", () => {
    api.rerender('51c7a00f', render)
  })

}


export default __exports__